import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Fade } from "react-awesome-reveal";
import cIcon1 from '../../images/icon/cp-icon.svg';
import cIcon2 from '../../images/icon/loc-icon.svg';
import cIcon3 from '../../images/icon/clock-icon.svg';
import { jobListings } from '../../api/joblistings';

const CareerTeam = () => {
    const [activeFilter, setActiveFilter] = useState("*");
    const [expandedJob, setExpandedJob] = useState(null);

    const handleFilter = (category) => {
        setActiveFilter(category);
    };

    const filters = [
        { key: "*", label: "All Roles" },
        { key: "technical", label: "Technical/Product" },
        { key: "growth", label: "Growth/Marketing" },
        { key: "operations", label: "Operations/Management" },
        { key: "customer", label: "Customer Experience" },
    ];

    const toggleJob = (jobId) => {
        setExpandedJob(expandedJob === jobId ? null : jobId);
    };

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };

    return (
        <section className="team pt-130 pb-130">
            <div className="container">
                <div className="sec-title--two text-center mb-50">
                    <Fade direction='down' triggerOnce={'false'} duration={1000} delay={9}>
                        <div>
                            <div className="sub-title wow fadeInDown" data-wow-duration="600ms">
                                <img src={cIcon1} alt="icon" />
                                Open Positions
                            </div>
                        </div>
                    </Fade>
                    <Fade direction='up' triggerOnce={'false'} duration={1200} delay={9}>
                        <div>
                            <h2 className="title wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms">
                                Join our team
                            </h2>
                        </div>
                    </Fade>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-12 text-center">
                        <div className="team-menu mb-50">
                            {filters.map((filter, index) => (
                                <button
                                    key={index}
                                    className={activeFilter === filter.key ? "active" : ""}
                                    onClick={() => handleFilter(filter.key)}
                                >
                                    {filter.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="col-lg-12">
                        <div className="cp-team-wrap grid">
                            <AnimatePresence>
                                {jobListings
                                    .filter(
                                        (job) => activeFilter === "*" || job.categories.includes(activeFilter)
                                    )
                                    .map((job) => (
                                        <motion.div
                                            key={job.id}
                                            className={`cp-team-item grid-item ${job.categories.join(" ")}`}
                                            initial={{ opacity: 0, scale: 0.9 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            exit={{ opacity: 0, scale: 0.9 }}
                                            transition={{ duration: 0.3 }}
                                        >
                                            <div className="xb-item--inner ul_li_between">
                                                <div className="xb-item--content">
                                                    <h3 className="xb-item--title" onClick={() => toggleJob(job.id)}>
                                                        {job.title}
                                                    </h3>
                                                    <div className="xb-item--holder ul_li">
                                                        <span className="xb-item--meta">
                                                            <img src={cIcon2} alt="location" />
                                                            {job.location}
                                                        </span>
                                                        <span className="xb-item--meta">
                                                            <img src={cIcon3} alt="time" />
                                                            {job.type}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="cp-team-btn">
                                                    <button 
                                                        className="cp-btn" 
                                                        onClick={() => toggleJob(job.id)}
                                                    >
                                                        {expandedJob === job.id ? "Less" : "More"} 
                                                        <i className={`fal fa-chevron-${expandedJob === job.id ? "up" : "down"}`}></i>
                                                    </button>
                                                </div>
                                            </div>

                                            <AnimatePresence>
                                                {expandedJob === job.id && (
                                                    <motion.div
                                                        initial={{ opacity: 0, height: 0 }}
                                                        animate={{ opacity: 1, height: "auto" }}
                                                        exit={{ opacity: 0, height: 0 }}
                                                        transition={{ duration: 0.3 }}
                                                        className="job-details"
                                                    >
                                                        <div className="xb-item--description">
                                                            <h4>Job Description</h4>
                                                            <p>{job.description}</p>
                                                            
                                                            <h4>Key Responsibilities:</h4>
                                                            <ul className="role-list">
                                                                {job.roles.map((role, index) => (
                                                                    <li key={index}>
                                                                        <i className="fas fa-chevron-right"></i>
                                                                        {role}
                                                                    </li>
                                                                ))}
                                                            </ul>

                                                            <div className="compensation">
                                                                <h4>Compensation & Benefits:</h4>
                                                                <ul>
                                                                    <li>Annual Salary: {job.pay}</li>
                                                                    <li>Performance Bonuses</li>
                                                                    <li>Health Insurance Coverage</li>
                                                                    <li>Flexible Working Hours</li>
                                                                    <li>Professional Development Budget</li>
                                                                </ul>
                                                            </div>
                                                            <Link 
                                                                to={`/career-details/${job.id}`} 
                                                                className="thm-btn thm-btn--aso"
                                                                onClick={scrollToTop}
                                                            >
                                                                Apply Now
                                                            </Link>
                                                        </div>
                                                    </motion.div>
                                                )}
                                            </AnimatePresence>
                                        </motion.div>
                                    ))}
                            </AnimatePresence>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CareerTeam;